import { z } from "zod";

export const BillingPaymentMethodItemSchema = z.object({
  Id: z.string().uuid(),
  LegalEntityId: z.string().uuid().nullable().optional(),
  LegalEntityName: z.string().nullable().optional(),
  Name: z.string().nullable().optional(),
  DisplayName: z.string().nullable().optional(),
  Phone: z.string().nullable().optional(),
  ReasonOfDecline: z.string().nullable().optional(),
  PaystandCardId: z.string().nullable().optional(),
  PaystandId: z.string().nullable().optional(),
  TypeName: z.string().nullable().optional(),
  Last4: z.string().nullable().optional(),
  CardBrand: z.string().nullable().optional(),
  CardHolder: z.string().nullable().optional(),
  CardExpDate: z.string().nullable().optional(),
  CardIsValid: z.boolean().nullable().optional(),
  AchAccountNumber: z.string().nullable().optional(),
  AchAuthorizedPerson: z.string().nullable().optional(),
  AchBankBranch: z.string().nullable().optional(),
  AchDepositoryBankName: z.string().nullable().optional(),
  AchRoutingNumber: z.string().nullable().optional(),
  AddressLine1: z.string().nullable().optional(),
  AddressLine2: z.string().nullable().optional(),
  AddressCity: z.string().nullable().optional(),
  AddressState: z.string().nullable().optional(),
  AddressPostalCode: z.string().nullable().optional(),
  AddressCountyId: z.string().uuid().nullable().optional(),
  AddressCountyName: z.string().nullable().optional(),
  AddressComposite: z.string().nullable().optional(),
  TypeCode: z.number().nullable().optional(),
  StateCode: z.number().optional(),
  StatusCode: z.number().optional(),
  AchAccountHolderTypeCode: z.number().nullable().optional(),
  LegalEntityTypeCode: z.number().nullable().optional(),
  AchAccountTypeCode: z.number().nullable().optional(),
  CardTypeCode: z.number().nullable().optional(),
});

export type BillingPaymentMethodItemType = z.infer<
  typeof BillingPaymentMethodItemSchema
>;
